import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";

import translationEN from "./translations/en.json";
import translationES from "./translations/es.json";
import translationBR from "./translations/br.json";
import translationDE from "./translations/de.json";
import translationFR from "./translations/fr.json";
import translationIT from "./translations/it.json";
import translationJA from "./translations/ja.json";
import translationRU from "./translations/ru.json";
import translationZH from "./translations/zh.json";
import translationTH from "./translations/th.json";

import en_GB from 'date-fns/locale/en-US';
import es_ES from 'date-fns/locale/es';
import pt_BR from 'date-fns/locale/pt-BR';
import de_DE from 'date-fns/locale/de';
import fr_FR from 'date-fns/locale/fr';
import it_IT from 'date-fns/locale/it';
import ja_JP from 'date-fns/locale/ja';
import ru_RU from 'date-fns/locale/ru';
import zh_CN from 'date-fns/locale/zh-CN';
import th_TH from 'date-fns/locale/th';

const resources = {
    en_GB: { translation: translationEN },
    es_ES: { translation: translationES },
    pt_BR: { translation: translationBR },
    de_DE: { translation: translationDE },
    fr_FR: { translation: translationFR },
    it_IT: { translation: translationIT },
    ja_JP: { translation: translationJA },
    ru_RU: { translation: translationRU },
    zh_CN: { translation: translationZH },
    th_TH: { translation: translationTH }
};

const queryString = globalThis.location.search;
const queryParams = new URLSearchParams(queryString);

export const locale = resources[queryParams.get("locale")] ? queryParams.get("locale") : "en_GB";

const locales = {en_GB, es_ES, pt_BR, de_DE, fr_FR, it_IT, ja_JP, ru_RU, zh_CN, th_TH};

export const localeObject = locales[locale];

export function useStringSet()
{
    const { t } = useTranslation();

    return {
        'MESSAGE_INPUT__PLACE_HOLDER': t('sendbird.enter_message'),
        'MESSAGE_MENU__COPY': t('sendbird.copy'),
        'MESSAGE_MENU__REPLY': t('sendbird.reply'),
        'MESSAGE_MENU__EDIT': t('sendbird.edit'),
        'MESSAGE_MENU__DELETE': t('sendbird.delete'),
        'USER_PROFILE__MESSAGE': t('sendbird.user_message'),
        'USER_PROFILE__USER_ID': t('sendbird.user_id'),
        'TOOLTIP__AND_YOU': t('sendbird.and_you'),
        'TOOLTIP__YOU': t('sendbird.you'),
        'MODAL__DELETE_MESSAGE__TITLE': t('sendbird.delete_message'),
        'BUTTON__CANCEL': t('sendbird.cancel'),
        'BUTTON__SAVE': t('sendbird.save'),
        'QUOTED_MESSAGE__REPLIED_TO': t('sendbird.replied_to'),
        'QUOTE_MESSAGE_INPUT__REPLY_TO': t('sendbird.reply_to'),
        'MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER': t('sendbird.reply_to_message'),
        'MESSAGE_EDITED': t('sendbird.edited'),
        'QUOTED_MESSAGE__CURRENT_USER': t('sendbird.you'),
    };
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en_GB",
        interpolation: {
            escapeValue: false
        },
        lng: locale
    });
